import { render, staticRenderFns } from "./BudgetDetails.vue?vue&type=template&id=cfeeba9c"
import script from "./BudgetDetails.vue?vue&type=script&lang=js"
export * from "./BudgetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports